<div class="flex flex-direction-column" *ngIf="!canClose" style="overflow: hidden">
	<div class="flex-1" *ngIf="!finished">
		<mat-progress-bar class="progress-bar" matSuffix mode="indeterminate" diameter="16"></mat-progress-bar>
	</div>
	<div class="flex" style="overflow-y: auto; white-space: pre-wrap" #content>
		<div *ngFor="let part of messages">
			<ng-container *ngIf="part?.level; else noLevel">
				<span [class]="part.level.toLowerCase()">{{ part.level }}</span>:
				<span [ngClass]="part.level.toLowerCase() === 'error' ? 'error' : ''">{{ part.message || part.text || part }}</span>
			</ng-container>
			<ng-template #noLevel>
				<span class="info">INFO</span>:
				<span>{{ part.message || part.text || part }}</span>
			</ng-template>
		</div>
	</div>
	<div class="flex-5 flex-direction-row flex-align-center flex-justify-center" *ngIf="finished">
		<button mat-button id="copy_button" color="accent" style="transform-style: preserve-3d" (click)="copy()">
			<span class="flex-direction-row flex-align-center">
				<mat-icon>content_copy</mat-icon>&nbsp;{{ 'i18n.matTreeCopy' | translate }}
			</span>
		</button>
		<span class="flex-auto"></span>
		<button mat-button id="ok_button" color="accent" style="transform-style: preserve-3d" (click)="close()">
			<span class="flex-direction-row flex-align-center">
				<mat-icon>close</mat-icon>&nbsp;{{ 'i18n.close' | translate }}
			</span>
		</button>
	</div>
</div>
